import { gql } from "@apollo/client";

export const GET_ADMIN_USERS = gql`
query getAdminUsers($enabled: Boolean) {
  getAdminUsers(enabled: $enabled) {
    status
    error
    users {
      userid
      username
      phone
      name
      enabled
      datetimecreated
      datetimeupdated
      permissions
      email
    }
  }
}`;

export const GET_ADMIN_USER = gql`
query getAdminUser($userid: String, $phone: String) {
  getAdminUser(userid: $userid, phone: $phone) {
    status
    error
    user {
      userid
      username
      phone
      name
      enabled
      datetimecreated
      datetimeupdated
      permissions
      email
    }
  }
}`;